import { AxiosError } from 'axios'

function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).isAxiosError !== undefined
}

export default class AxiosApiError extends Error {
  status: number | undefined = 500

  constructor(error: unknown) {
    super(isAxiosError(error) ? error.response?.statusText : 'unknown error')

    if (isAxiosError(error)) {
      // Axios bug, returns 0 in server error, later can be deleted.
      if (error.request.status === 0) {
        this.status = 503
      } else {
        this.status = error.request.status
      }
    } else {
      this.status = 500
    }
    Error.captureStackTrace(this, AxiosApiError)
  }
}
